import { render, staticRenderFns } from "./DownloadNotificactionDropdown.vue?vue&type=template&id=e81c27d6"
import script from "./DownloadNotificactionDropdown.vue?vue&type=script&lang=js"
export * from "./DownloadNotificactionDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports